import DeleteIcon from 'assets/settings/components/DeleteIcon';
import EditIcon from 'assets/settings/components/EditIcon';
import WorkflowIcon from 'assets/settings/components/WorkflowIcon';

import {
  ActionButton,
  ActionsSection,
  Badge,
  BadgesWrapper,
  Card,
  ColorBlock,
  ColorCircle,
  ColorIndicator,
  ContentSection,
  Description,
  HeaderSection,
  Title,
} from './WorkflowStatusCard.styles';

const WorkflowStatusCard = ({
  name,
  description,
  color,
  enabled,
  statusType,
  isDefault,
  onEdit,
  onDelete,
}) => {
  const canDelete = !isDefault;

  const getBadgeType = (type) => {
    if (!type) return 'none';
    return type.toLowerCase();
  };
  return (
    <Card>
      <ColorBlock $color={color}>
        <WorkflowIcon size={24} color="#FFFFFF" />
      </ColorBlock>

      <ContentSection>
        <HeaderSection>
          <Title title={name}>{name}</Title>
          <BadgesWrapper>
            {statusType && <Badge $type={getBadgeType(statusType)}>{statusType}</Badge>}
            {isDefault && <Badge $type="default">Default</Badge>}
            <Badge $type={enabled ? 'status-enabled' : 'status-disabled'}>
              {enabled ? 'Enabled' : 'Disabled'}
            </Badge>
          </BadgesWrapper>
        </HeaderSection>

        {description && <Description title={description}>{description}</Description>}

        <ColorIndicator>
          <ColorCircle $color={color} />
          <span>Color: {color}</span>
        </ColorIndicator>
      </ContentSection>

      <ActionsSection>
        <ActionButton onClick={onEdit}>
          <EditIcon size={16} color="#2D6CDF" />
        </ActionButton>
        {canDelete && (
          <ActionButton onClick={onDelete} $delete>
            <DeleteIcon size={16} color="#FB2C36" />
          </ActionButton>
        )}
      </ActionsSection>
    </Card>
  );
};

export default WorkflowStatusCard;
